// extracted by mini-css-extract-plugin
export default {"container":"TR-z","leftColumn":"UR-z","rightColumn":"VR-z","item":"WR-z"};